import { Alert, IconButton, Snackbar } from '@mui/material';
import * as React from 'react';
import { useUserNotificationStoreFeedbackMessage } from '../../../stores/UserNotificationStore';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { AlertTitle } from '@mui/material';

interface ICopyToClipBoardButtonProps{
    text: string
}

const CopyToClipboardButton = (props: ICopyToClipBoardButtonProps) => {
    const handleClick = () => navigator.clipboard.writeText(props.text)
  
    return <><IconButton size='small' onClick={handleClick}><ContentCopyIcon></ContentCopyIcon></IconButton></>
}

export default function UserNotification() {
    const [open, setOpen] = React.useState(false);
    const feedbackMessage = useUserNotificationStoreFeedbackMessage();

    React.useEffect(() => {
        setOpen(feedbackMessage ? true : false)
    }, [feedbackMessage])

  
    return (
        <Snackbar
            autoHideDuration={7000}
            open={open}
            style={{zIndex: 999999}}
            onClose={(_event, reason) => {
                if (reason !== "clickaway") {
                    setOpen(false)
                }
            }} 
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
                <Alert
                    severity={feedbackMessage ? feedbackMessage.severity : 'info'}
                    sx={{ width: "100%" }}
                    onClose={() => setOpen(false)}>
                    
                    {feedbackMessage && feedbackMessage.severity === 'error' && <AlertTitle><strong>Feilmelding</strong></AlertTitle>}
                    {feedbackMessage ? feedbackMessage.message : ''}

                    {feedbackMessage && feedbackMessage.severity !== 'success' &&
                        <CopyToClipboardButton text={feedbackMessage ? feedbackMessage.message : ''} />
                    }
                    
                </Alert>
        </Snackbar>
    );
}
